const Bing = {
  send(name) {
    window.uetq = window.uetq || []

    if (!window.uetq) return console.info('BING: send event:', name) // eslint-disable-line

    return window.uetq.push('event', name, {})
  }
}

export default Bing
